/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";

const initState = "week"; // day, week, month
const initScale = 1;

const TableViewGanttOptionsContext = React.createContext(initState);
export const useGanttOptions = () =>
    React.useContext(TableViewGanttOptionsContext);

const TableViewGanttOptionsSwitchContext = React.createContext(() => {});
export const useSwitchGanttOptions = () =>
    React.useContext(TableViewGanttOptionsSwitchContext);

const GanttScaleContext = React.createContext(initScale);
export const useGanttScale = () => React.useContext(GanttScaleContext);

const GanttScaleSwitchContext = React.createContext(() => {});
export const useSwitchGanttScale = () =>
    React.useContext(GanttScaleSwitchContext);

export default ({ children }) => {
    const [value, setValue] = React.useState(() => initState);
    const [scale, setScale] = React.useState(() => initScale);
    return (
        <TableViewGanttOptionsContext.Provider value={value}>
            <TableViewGanttOptionsSwitchContext.Provider
                value={(v) => {
                    setValue(v);
                }}
            >
                <GanttScaleContext.Provider value={scale}>
                    <GanttScaleSwitchContext.Provider
                        value={(v) => {
                            setScale(v);
                        }}
                    >
                        {children}
                    </GanttScaleSwitchContext.Provider>
                </GanttScaleContext.Provider>
            </TableViewGanttOptionsSwitchContext.Provider>
        </TableViewGanttOptionsContext.Provider>
    );
};
